
namespace TabAurous.Purchase{

    @Serenity.Decorators.registerClass()
    export class ApprovalInReturnItemsGrid extends Serenity.EntityGrid<ApprovalInReturnItemsRow, any> {
        protected getColumnsKey() { return 'Purchase.ApprovalInReturnItems'; }
        protected getDialogType() { return ApprovalInReturnItemsDialog; }
        protected getIdProperty() { return ApprovalInReturnItemsRow.idProperty; }
        protected getInsertPermission() { return ApprovalInReturnItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalInReturnItemsRow.localTextPrefix; }
        protected getService() { return ApprovalInReturnItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}